/* eslint-disable func-names */
import React, { Component, createRef  } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { setFlag, getEITShopSoldStat, getEITShopSold, getLatestShopSold } from '../actions';
import { CONFIGS } from '../configs';
import { ToastContainer, toast } from 'react-toastify';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { CircleSpinnerOverlay, FerrisWheelSpinner } from 'react-spinner-overlay'
import {
    Badge,
    Button,
    Card,
    Form,
    Navbar,
    Nav,
    Container,
    Row,
    Col,
    Table
  } from "react-bootstrap";

import { FaChartPie } from "react-icons/fa";
import socket from '../socket';

import moment from "moment";

class ShopSoldChart extends Component {
  constructor() {
    super();
    this.chartRef = createRef();
    this.state = {
      chartData: [],
      latestShopSold: "",
      highlightedIndex: null,
      hourlySoldData: [],
      dailySoldData: []
    };
  }

  fetchData(viewMode, shopTeam) {
    if (shopTeam) {
      var shopNames = shopTeam.split(",");
      // shopNames.map(shopName => this.props.getLatestShopSold(shopName));
    } else {
      this.props.getLatestShopSold(this.props.shopName);
    } 
  }

  componentDidMount() {
    this.fetchData(this.props.viewMode, this.props.shopTeam);
    
    this.interval = setInterval(() => {
      this.updateHighlight();
    }, 900);
  }

  highlightedIndex = null;
  blinkingEnabled = false;

  updateHighlight = () => {
    this.blinkingEnabled = !this.blinkingEnabled;

    try {
      const chart = this.chartRef.current.chart;
      const viewMode = this.props.viewMode;
      
      // Skip blinking for CUSTOM_RANGE as it has its own highlighting logic
      if (viewMode === 'CUSTOM_RANGE') {
        return;
      }
      
      var currentIndex = 0;

      switch (viewMode) {
        case CONFIGS.VIEW_MODE_SHOP_SOLD.TODAY:
          currentIndex = this.state.hourlySoldData.length - 1;
          break;

        case CONFIGS.VIEW_MODE_SHOP_SOLD.BLACK_FRIDAY:
          currentIndex = this.state.hourlySoldData.length - 1 - 12;
          break;

        case CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_7_DAYS:
          currentIndex = 6;
          break;

        case CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_14_DAYS:
          currentIndex = 13;
          break;

        case CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_30_DAYS:
          currentIndex = 29;
          break;
          
        case 'CUSTOM_RANGE':
          // For custom range, don't use blinking - highlighting is handled separately
          currentIndex = -1; // No blinking for custom range
          break;
      }

      this.chartData.forEach((item, index) => {
        chart.series[0].data[index].update({
          color: index === currentIndex && this.blinkingEnabled ? 'red' : '#2CAFFE',
        }, false); // false để tránh re-render toàn bộ
      });
  
      chart.redraw(); // Cập nhật thay đổi mà không cần render lại toàn bộ component
    } catch {

    }

    socket.on('message', (message) => { 
      console.log(message);
      // this.props.addMessage(getTimeNow() + " From server : " + message);
    })
  };

  renderOptions = () => {
    const { latestShopSold, shopName, hourlySoldData, dailySoldData } = this.state;
    const { viewMode } = this.props;
    var totalSold = 0;
    var chartName = "";

    var data = [];
    var yMax = 0; // Sẽ được set dựa trên viewMode

    if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.TODAY 
      || viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.BLACK_FRIDAY
    ) {
      // Theo giờ: max team: 20 sold, shop: 10
      yMax = this.props.shopTeam ? 20 : 10;
      
      const currentDate = moment().format('DD/MM');
      chartName = `Đơn Etsy ngày ${currentDate}`;

      if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.BLACK_FRIDAY)
        chartName = "Black Friday 2024 - Giờ US"

      let dHour = (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.TODAY) ? 0: 12;
      let shopSoldToday = (hourlySoldData && hourlySoldData.length > 0) ? hourlySoldData.slice(1 + dHour): [];

      var data = shopSoldToday.map(soldData => {
        totalSold += soldData.delta_sold;
        const date = new Date(soldData.timestamp * 1000);
  
        // Lấy giờ từ đối tượng Date
        // const hours = date.getHours(); 
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
  
        return [date.getTime(), soldData.delta_sold]
      });
  
      if (latestShopSold && hourlySoldData.length > 0) {
        var lastHourTotalSold = hourlySoldData[hourlySoldData.length-1].total_sold;
        var currentHourTotalSold = latestShopSold.total_sold;
        var currentHourDeltaSold = currentHourTotalSold - lastHourTotalSold;
        totalSold += currentHourDeltaSold;
  
        const date = new Date(latestShopSold.timestamp * 1000);

        // Lấy giờ từ đối tượng Date
        const hours = date.getHours(); 
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        
        if (currentHourDeltaSold>0)
          data.push([date.getTime(), currentHourDeltaSold])
      }
  
      const now = new Date();
  
      for (var i = data.length; i<23; i++) {
        let date = new Date(now.getTime());

        // Lấy giờ từ đối tượng Date
        date.setHours(i, 0, 0, 0); 
  
        data.push([date.getTime(), 0])
      }
    } else if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.YESTERDAY) {
      // Theo giờ: max team: 20 sold, shop: 10
      yMax = this.props.shopTeam ? 20 : 10;
      
      const yesterdayDate = moment().subtract(1, 'days').format('DD/MM');
      chartName = `Đơn Etsy ngày ${yesterdayDate}`;
      
      // Get yesterday's hourly data
      // We need to filter hourlySoldData for yesterday (24 hours ago to 48 hours ago)
      const yesterdayStartTimestamp = moment().subtract(1, 'days').startOf('day').unix();
      const yesterdayEndTimestamp = moment().subtract(1, 'days').endOf('day').unix();
      
      let shopSoldYesterday = [];
      if (hourlySoldData && hourlySoldData.length > 0) {
        shopSoldYesterday = hourlySoldData.filter(soldData => 
          soldData.timestamp >= yesterdayStartTimestamp && soldData.timestamp <= yesterdayEndTimestamp
        );
      }

      var data = shopSoldYesterday.map(soldData => {
        totalSold += soldData.delta_sold;
        const date = new Date(soldData.timestamp * 1000);
  
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
  
        return [date.getTime(), soldData.delta_sold]
      });

      // Fill missing hours with 0 for yesterday (0-23)
      const yesterdayStart = moment().subtract(1, 'days').startOf('day');
      for (var i = 0; i < 24; i++) {
        const hourTime = yesterdayStart.clone().add(i, 'hours').valueOf();
        const existingData = data.find(item => item[0] === hourTime);
        if (!existingData) {
          data.push([hourTime, 0]);
        }
      }
      
      // Sort data by timestamp
      data.sort((a, b) => a[0] - b[0]);
    } else if (viewMode === 'CUSTOM_RANGE') {
      // Handle custom date range
      const customStartDate = this.props.customStartDate || moment().subtract(7, 'days').toDate();
      const customEndDate = this.props.customEndDate || moment().toDate();
      const numberOfDays = moment(customEndDate).diff(moment(customStartDate), 'days') + 1;
      const isSingleDay = numberOfDays === 1;
      
      const fromDay = moment(customStartDate).format('DD/MM');
      const toDay = moment(customEndDate).format('DD/MM');
      
      if (isSingleDay) {
        // Theo giờ: max team: 20 sold, shop: 10
        yMax = this.props.shopTeam ? 20 : 10;
        chartName = `Đơn Etsy ngày ${fromDay}`;
      } else {
        // Theo ngày: max team: 200 sold, shop: 100
        yMax = this.props.shopTeam ? 200 : 100;
        chartName = `Đơn Etsy từ ${fromDay} đến ${toDay}`;
      }
      
      if (isSingleDay) {
        // Single day: show hourly data (like TODAY/YESTERDAY)
        const selectedDateStart = moment(customStartDate).startOf('day').unix();
        const selectedDateEnd = moment(customStartDate).endOf('day').unix();
        
        console.log('DEBUG Custom Single Day:');
        console.log('- Selected Date:', moment(customStartDate).format('DD/MM/YYYY'));
        console.log('- selectedDateStart:', selectedDateStart, '(' + moment.unix(selectedDateStart).format('DD/MM/YYYY HH:mm') + ')');
        console.log('- selectedDateEnd:', selectedDateEnd, '(' + moment.unix(selectedDateEnd).format('DD/MM/YYYY HH:mm') + ')');
        console.log('- hourlySoldData length:', hourlySoldData ? hourlySoldData.length : 0);
        console.log('- dailySoldData length:', dailySoldData ? dailySoldData.length : 0);
        
        let selectedDayHourlySold = [];
        if (hourlySoldData && hourlySoldData.length > 0) {
          console.log('- First hourlySoldData item:', hourlySoldData[0]);
          console.log('- Last hourlySoldData item:', hourlySoldData[hourlySoldData.length - 1]);
          
          selectedDayHourlySold = hourlySoldData.filter(soldData => 
            soldData.timestamp >= selectedDateStart && soldData.timestamp <= selectedDateEnd
          );
          
          console.log('- Filtered selectedDayHourlySold length:', selectedDayHourlySold.length);
          if (selectedDayHourlySold.length > 0) {
            console.log('- First filtered item:', selectedDayHourlySold[0]);
            console.log('- Last filtered item:', selectedDayHourlySold[selectedDayHourlySold.length - 1]);
          }
        }

        var data = selectedDayHourlySold.map(soldData => {
          totalSold += soldData.delta_sold;
          const date = new Date(soldData.timestamp * 1000);
          date.setMinutes(0);
          date.setSeconds(0);
          date.setMilliseconds(0);
          return [date.getTime(), soldData.delta_sold]
        });

        // If no hourly data found, try to use daily data as fallback
        if (selectedDayHourlySold.length === 0 && dailySoldData && dailySoldData.length > 0) {
          console.log('- No hourly data found, trying dailySoldData fallback...');
          
          // Find daily data for selected date
          const selectedDayData = dailySoldData.find(dayData => {
            const dayTimestamp = moment.unix(dayData.timestamp).startOf('day').unix();
            return dayTimestamp === selectedDateStart;
          });
          
          if (selectedDayData) {
            console.log('- Found dailySoldData for selected day:', selectedDayData);
            
            // Find previous day for delta calculation
            const previousDayData = dailySoldData.find(dayData => {
              const dayTimestamp = moment.unix(dayData.timestamp).startOf('day').unix();
              const previousDayTimestamp = moment.unix(selectedDateStart).subtract(1, 'day').startOf('day').unix();
              return dayTimestamp === previousDayTimestamp;
            });
            
            let dayDeltaSold = 0;
            if (previousDayData) {
              dayDeltaSold = selectedDayData.total_sold - previousDayData.total_sold;
              console.log('- Calculated day delta sold:', dayDeltaSold);
            } else {
              // No previous day data, use total_sold as fallback
              dayDeltaSold = selectedDayData.total_sold;
              console.log('- No previous day data, using total_sold:', dayDeltaSold);
            }
            
            // Distribute daily sold across 24 hours (simple distribution)
            const avgHourlySold = Math.floor(dayDeltaSold / 24);
            const remainderSold = dayDeltaSold % 24;
            
            for (var i = 0; i < 24; i++) {
              const hourTime = moment(customStartDate).startOf('day').add(i, 'hours').valueOf();
              let hourlySold = avgHourlySold;
              
              // Distribute remainder to first few hours
              if (i < remainderSold) {
                hourlySold += 1;
              }
              
              data.push([hourTime, hourlySold]);
              totalSold += hourlySold;
            }
            
            console.log('- Generated hourly data from daily data, totalSold:', totalSold);
          } else {
            console.log('- No dailySoldData found for selected day');
          }
        }

        // Fill in missing hours with 0 (only if we still don't have data)
        if (data.length === 0) {
          const selectedDayStart = moment(customStartDate).startOf('day');
          for (var i = 0; i < 24; i++) {
            const hourTime = selectedDayStart.clone().add(i, 'hours').valueOf();
            data.push([hourTime, 0]);
          }
        }
        
        data.sort((a, b) => a[0] - b[0]);
        
        // Set highlighted index ONLY if selected date is today
        if (moment(customStartDate).isSame(moment(), 'day')) {
          this.highlightedIndex = moment().hour(); // Current hour for today
        } else {
          this.highlightedIndex = null; // No highlight for past days
        }
        
      } else {
        // Multiple days: show daily data
        const fromDayTimestamp = moment(customStartDate).startOf('day').valueOf();
        const toDayTimestamp = moment(customEndDate).endOf('day').valueOf();
        const filteredDailySoldData = dailySoldData.filter(item => {
          const itemTimestamp = item.timestamp * 1000; // Convert to milliseconds
          return itemTimestamp >= fromDayTimestamp && itemTimestamp <= toDayTimestamp;
        });

        // Sort filtered data by timestamp
        filteredDailySoldData.sort((a, b) => a.timestamp - b.timestamp);

        // Create all dates in range to ensure we show every day
        const allDatesInRange = [];
        for (let d = moment(customStartDate); d.isSameOrBefore(moment(customEndDate)); d.add(1, 'day')) {
          allDatesInRange.push(d.clone().startOf('day'));
        }

        // Process each date in the custom range
        for (let i = 0; i < allDatesInRange.length; i++) {
          const currentDate = allDatesInRange[i];
          const currentTimestamp = currentDate.unix();
          
          // Find data for current date
          const currentDayIndex = filteredDailySoldData.findIndex(item => 
            moment.unix(item.timestamp).startOf('day').unix() === currentTimestamp
          );
          
          let deltaSold = 0;
          
          if (currentDayIndex >= 0) {
            const currentDayData = filteredDailySoldData[currentDayIndex];
            
            if (currentDayIndex > 0) {
              // Calculate delta from previous day in filtered data
              const previousDayData = filteredDailySoldData[currentDayIndex - 1];
              deltaSold = currentDayData.total_sold - previousDayData.total_sold;
            } else {
              // First day in filtered data
              // Try to find data from day before custom range to calculate proper delta
              const dayBeforeStart = moment(customStartDate).subtract(1, 'day').startOf('day').unix();
              const dayBeforeData = dailySoldData.find(item => 
                moment.unix(item.timestamp).startOf('day').unix() === dayBeforeStart
              );
              
              if (dayBeforeData) {
                deltaSold = currentDayData.total_sold - dayBeforeData.total_sold;
              } else {
                // No previous reference, treat as 0 for first day
                deltaSold = 0;
              }
            }
          }
          // If no data for this date, deltaSold remains 0

          data.push([currentDate.valueOf(), Math.max(deltaSold, 0)]);
          totalSold += Math.max(deltaSold, 0);
        }

        // Handle today's data separately if custom range includes today and we have latest data
        if (latestShopSold && moment(customEndDate).isSame(moment(), 'day')) {
          const todayTimestamp = moment().startOf('day').unix();
          
          // Update today's data if we have more recent latestShopSold
          const todayIndex = data.findIndex(item => 
            moment(item[0]).startOf('day').unix() === todayTimestamp
          );
          
          if (todayIndex >= 0) {
            // Find yesterday's data for delta calculation
            const yesterdayTimestamp = moment().subtract(1, 'day').startOf('day').unix();
            const yesterdayData = filteredDailySoldData.find(item => 
              moment.unix(item.timestamp).startOf('day').unix() === yesterdayTimestamp
            );
            
            if (yesterdayData) {
              const todayDeltaSold = Math.max(latestShopSold.total_sold - yesterdayData.total_sold, 0);
              
              // Update today's data point
              data[todayIndex][1] = todayDeltaSold;
              
              // Recalculate totalSold
              totalSold = data.reduce((sum, item) => sum + item[1], 0);
            }
          }
        }
        
        // Set highlighted index ONLY if end date is today
        if (moment(customEndDate).isSame(moment(), 'day')) {
          // Find the index of end date (today) in the data array
          const endDateTimestamp = moment(customEndDate).startOf('day').unix();
          const endDateDataIndex = data.findIndex(item => 
            moment(item[0]).startOf('day').unix() === endDateTimestamp
          );
          
          console.log('DEBUG Highlighting:');
          console.log('- customEndDate:', moment(customEndDate).format('DD/MM/YYYY'));
          console.log('- today:', moment().format('DD/MM/YYYY'));
          console.log('- endDateTimestamp:', endDateTimestamp);
          console.log('- data.length:', data.length);
          console.log('- endDateDataIndex:', endDateDataIndex);
          
          if (endDateDataIndex >= 0) {
            this.highlightedIndex = endDateDataIndex;
            console.log('- Set highlightedIndex to:', endDateDataIndex);
          } else {
            // Fallback: if end date is the last day in range, use last index
            this.highlightedIndex = data.length - 1;
            console.log('- Fallback: Set highlightedIndex to last index:', data.length - 1);
          }
        } else {
          // End date is not today, no highlight
          this.highlightedIndex = null;
          console.log('DEBUG: End date is not today, no highlight');
        }
      }
    } else if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_7_DAYS
      || viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_14_DAYS
      || viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_30_DAYS
    ) {
      var numberOfDays = 0;

      if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_7_DAYS)
        numberOfDays = 7;
      else if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_14_DAYS)
        numberOfDays = 14;      
      else if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_30_DAYS)
          numberOfDays = 30;

      const fromDay = moment().subtract(numberOfDays - 1, 'days').format('DD/MM');
      const today = moment().format('DD/MM');
      chartName = `Đơn Etsy từ ${fromDay} đến ${today}`;
      // Theo ngày: max team: 200 sold, shop: 100
      yMax = this.props.shopTeam ? 200 : 100;
      
      // Tạo tất cả các ngày trong khoảng thời gian (từ fromDay đến today)
      const allDatesInRange = [];
      for (let d = moment().subtract(numberOfDays - 1, 'days'); d.isSameOrBefore(moment()); d.add(1, 'day')) {
        allDatesInRange.push(d.clone().startOf('day'));
      }

      // Filter dailySoldData để chỉ lấy data >= fromDay
      const fromDayTimestamp = moment().subtract(numberOfDays - 1, 'days').startOf('day').valueOf();
      const filteredDailySoldData = dailySoldData.filter(item => {
        const itemTimestamp = item.timestamp * 1000; // Convert to milliseconds
        return itemTimestamp >= fromDayTimestamp;
      });

      // Sắp xếp filteredDailySoldData theo timestamp
      filteredDailySoldData.sort((a, b) => a.timestamp - b.timestamp);

      // Xử lý từng ngày trong khoảng thời gian
      for (let i = 0; i < allDatesInRange.length; i++) {
        const currentDate = allDatesInRange[i];
        const currentTimestamp = currentDate.unix();
        
        // Tìm data cho ngày hiện tại
        const currentDayIndex = filteredDailySoldData.findIndex(item => 
          moment.unix(item.timestamp).startOf('day').unix() === currentTimestamp
        );
        
        let deltaSold = 0;
        
        if (currentDayIndex >= 0) {
          const currentDayData = filteredDailySoldData[currentDayIndex];
          
          if (currentDayIndex > 0) {
            // Tính delta từ ngày trước đó trong filtered data
            const previousDayData = filteredDailySoldData[currentDayIndex - 1];
            deltaSold = currentDayData.total_sold - previousDayData.total_sold;
          } else {
            // Ngày đầu tiên trong filtered data
            // Tìm data từ ngày trước khoảng thời gian để tính delta chính xác
            const dayBeforeStart = moment().subtract(numberOfDays, 'days').startOf('day').unix();
            const dayBeforeData = dailySoldData.find(item => 
              moment.unix(item.timestamp).startOf('day').unix() === dayBeforeStart
            );
            
            if (dayBeforeData) {
              deltaSold = currentDayData.total_sold - dayBeforeData.total_sold;
            } else {
              // Không có data tham chiếu trước đó, coi như 0 cho ngày đầu tiên
              deltaSold = 0;
            }
          }
        }
        // Nếu không có data cho ngày này, deltaSold vẫn là 0

        data.push([currentDate.valueOf(), Math.max(deltaSold, 0)]);
        totalSold += Math.max(deltaSold, 0);
      }
  
      // Xử lý dữ liệu mới nhất nếu có và nếu ngày cuối cùng trong khoảng là hôm nay
      if (latestShopSold && moment().isSame(allDatesInRange[allDatesInRange.length - 1], 'day')) {
        const todayTimestamp = moment().startOf('day').unix();
        
        // Cập nhật data cho hôm nay nếu có dữ liệu mới hơn
        const todayIndex = data.findIndex(item => 
          moment(item[0]).startOf('day').unix() === todayTimestamp
        );
        
        if (todayIndex >= 0) {
          // Tìm data của ngày hôm qua để tính delta
          const yesterdayTimestamp = moment().subtract(1, 'day').startOf('day').unix();
          const yesterdayData = filteredDailySoldData.find(item => 
            moment.unix(item.timestamp).startOf('day').unix() === yesterdayTimestamp
          );
          
          if (yesterdayData) {
            const todayDeltaSold = Math.max(latestShopSold.total_sold - yesterdayData.total_sold, 0);
            
            // Cập nhật data point cho hôm nay
            data[todayIndex][1] = todayDeltaSold;
            
            // Tính lại totalSold
            totalSold = data.reduce((sum, item) => sum + item[1], 0);
          }
        }
      }
    }

    this.chartData = data;

    if (this.props.updateTOP2TeamChartData && data.length > 0)
      this.props.updateTOP2TeamChartData(data);

    if (this.props.niche) {
      yMax = yMax * 4;
    } else {
      this.props.updateShopTotalSold(shopName, totalSold);
    }

    return {
      time: {
        timezoneOffset: -7 * 60 // GMT+7 (7 giờ so với GMT, mỗi giờ có 60 phút)
      },
      chart: {
        type: 'column'
      },
      title: {
        text: `<span style="color: black;">${this.props.niche? `SOLD ${this.props.shopTeam.split(",").length} SHOP`: shopName} </span><span style="color: red;">${this.props.niche? `${totalSold} (TỔNG ~${Math.round(totalSold / 0.9)})`: totalSold}</span>`,
        // text: `Đơn: </span><span style="color: red;">${totalSold}</span>`,
        useHTML: true, // Bật tính năng HTML cho title
      },
      xAxis: {
        type: 'datetime', // Đảm bảo rằng trục X là thời gian
        title: {
            // text: 'Giờ'
        },
        labels: {
          formatter: function() {
              // Lấy giờ từ timestamp
              let date = new Date(this.value);
              if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.TODAY || viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.YESTERDAY)
                return date.getHours() + "h";  // Chỉ lấy giờ và thêm "h"
              else if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.BLACK_FRIDAY) {
                date = new Date(this.value + 12 * 60 * 60 * 1000);
                return date.getHours() + "h";
              } else if (viewMode === 'CUSTOM_RANGE') {
                // Determine if single day by checking if all data points are on same day
                const firstDataPoint = data[0];
                const lastDataPoint = data[data.length - 1];
                
                if (firstDataPoint && lastDataPoint) {
                  const firstDate = moment(firstDataPoint[0]);
                  const lastDate = moment(lastDataPoint[0]);
                  const isSingleDay = firstDate.isSame(lastDate, 'day');
                  
                  if (isSingleDay) {
                    return date.getHours() + "h";
                  } else {
                    return moment(date).format("DD/MM");
                  }
                } else {
                  return moment(date).format("DD/MM");
                }
              } else if (viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_7_DAYS
                || viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_14_DAYS
                || viewMode == CONFIGS.VIEW_MODE_SHOP_SOLD.LAST_30_DAYS
              ) {
                return moment(date).format("DD/MM");
              }
          }
        }
      },
      yAxis: {
        // min: 0,
        max: yMax,
        title: {
          text: 'Sold'
        }
      },
      series: [{
        data: data.map((item, index) => {
          const isHighlighted = index === this.highlightedIndex;
          if (isHighlighted) {
            console.log('DEBUG: Highlighting bar at index', index, 'date:', moment(item[0]).format('DD/MM/YYYY HH:mm'));
          }
          return {
            x: item[0],
            y: item[1],
            color: isHighlighted ? 'red' : '#2CAFFE', // Highlight the specified index
          };
        }),
        name: chartName
        // name: `<span style="color: black; font-size: 20px; font-weight: bold">${this.state.shopName}`,
        // colorByPoint: true
      }],
      plotOptions: {
        column: {
            dataLabels: {
                enabled: true,
                crop: false,
                overflow: 'none'
            }
        }
      },
    }
    
    console.log('DEBUG Final renderOptions for', this.props.shopName, 'highlightedIndex:', this.highlightedIndex);
    return options;
  }
  

  componentWillReceiveProps(props) {
    var { shopName, soldData, viewMode, hourlySoldData, dailySoldData, shopTeam } = props;

    // console.log("ShopSoldChart - hourlySoldData", hourlySoldData);
    // console.log("ShopSoldChart - dailySoldData", dailySoldData);

    var latestShopSold = {};
    
    if (shopTeam) {
      var total_sold = 0;
      var latestTimestamp = 0;

      var shopNames = shopTeam.split(",");
      shopNames.map(shopName => {
        var currentLatestShopSold = soldData[shopName]? soldData[shopName].latestShopSold: "";
        
        if (currentLatestShopSold) {
          total_sold += currentLatestShopSold.total_sold;

          if (latestTimestamp < currentLatestShopSold.timestamp)
            latestTimestamp = currentLatestShopSold.timestamp;
        }
      });

      latestShopSold = (total_sold > 0)? {
        timestamp: latestTimestamp,
        total_sold
      }: "";
    } else {
      latestShopSold = soldData[shopName]? soldData[shopName].latestShopSold: "";
    }

    console.log("KKK latestShopSold ", shopName, latestShopSold);

    this.setState({ shopName, viewMode, latestShopSold, hourlySoldData, dailySoldData })
  } 

  render() {
    return <Container className="shop-sold-chart">
      <Row>
        <span className="view-shop-listing-sold">
          <FaChartPie 
            onClick={e => this.props.handleShowShopListingSold(this.props.shopName)} 
            title="View listing sold detail"
          />
        </span>
        
        {this.state.hourlySoldData && this.state.hourlySoldData.length > 0 ?
        <HighchartsReact
          highcharts={Highcharts}
          options={this.renderOptions()}
          ref={this.chartRef}
        />: <div class="loading">
        <FerrisWheelSpinner loading={true}　color="#17a2b8" />
      </div>}
      </Row>
      <Row className="mt-2 text-center text-bold">
        {!this.props.niche && this.props.shopTeam && this.props.shopTeam.split(",")
          .map(shopName => <span><a href={`https://etsy.com/shop/${shopName}`} target="_blank">{shopName}</a></span>)}
      </Row>
    </Container>
  }
}

const mapStateToProps = (state) => {
  return {
    soldData: state.eitShopSoldReducer.soldData
  };
};

export default connect(mapStateToProps, { setFlag, getEITShopSoldStat, getEITShopSold, getLatestShopSold })(ShopSoldChart);